import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=210fde3d&scoped=true&"
import script from "./CallToAction.vue?vue&type=script&lang=ts&"
export * from "./CallToAction.vue?vue&type=script&lang=ts&"
import style0 from "./CallToAction.vue?vue&type=style&index=0&id=210fde3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fde3d",
  null
  
)

export default component.exports